import { loadLastEventForDeviceAsync } from "@/base/farmhq-api"
import { useErrorHandler } from "@/hooks/useErrorHandler"
import * as Models from "@/redux/models"
import { useRootDispatch } from "@/redux/useRootDispatch"
import { useRootSelector } from "@/redux/useRootSelector"
import React from "react"

const INTERVAL_SECONDS = 2

function ForceUpdateDispatcher({ deviceId }: Models.DeviceIdProps) {
  const dispatch = useRootDispatch()
  const previousEventId = useRootSelector(
    (state) => Models.deviceEventLast.selectById(state, deviceId)?.id ?? null,
  )
  const handleError = useErrorHandler({ isBackgroundPoll: true })
  React.useEffect(() => {
    const interval = setInterval(() => {
      dispatch(
        loadLastEventForDeviceAsync({ deviceId, previousEventId }),
      ).catch((error) => {
        handleError(error)
      })
    }, INTERVAL_SECONDS * 1000)
    return () => {
      clearInterval(interval)
    }
  }, [deviceId, dispatch, handleError, previousEventId])
  return null
}
export function ForceUpdateManager() {
  const ids = useRootSelector(Models.deviceCommandTracker.selectIds)

  return (
    <React.Fragment>
      {ids.map((deviceId) => (
        <ForceUpdateDispatcher key={deviceId} deviceId={deviceId} />
      ))}
    </React.Fragment>
  )
}
